import React, { memo } from 'react';
export const Pricing = () => {
  return <section className="w-full px-6 py-20 md:px-12 md:py-28 bg-black relative" data-id="element-92">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(255,255,255,0.05),transparent_50%)] pointer-events-none" data-id="element-93"></div>
      <div className="max-w-6xl mx-auto relative" data-id="element-94">
        <h1 className="text-3xl md:text-5xl font-serif font-light text-center mb-6" data-id="element-95">
          Investment in Your <span className="text-white" data-id="element-96">Digital Legacy</span>
        </h1>
        <p className="text-center text-zinc-300 mb-16 max-w-2xl mx-auto" data-id="element-97">
          Choose your path to digital immortality with our carefully crafted
          preservation tiers. Each tier represents a different level of
          consciousness preservation and interaction capability.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-98">
          {/* Essence Tier */}
          <div className="border border-white/10 p-8 rounded-sm hover:border-white/20 transition-colors backdrop-blur-sm bg-gradient-to-b from-zinc-900/50 to-black/50" data-id="element-99">
            <h3 className="text-2xl font-light mb-2" data-id="element-100">Essence</h3>
            <p className="text-white text-3xl mb-6" data-id="element-101">$10,000</p>
            <ul className="space-y-3 mb-8 text-zinc-300" data-id="element-102">
              <li data-id="element-103">Core personality preservation</li>
              <li data-id="element-104">Digital memory archival</li>
              <li data-id="element-105">Basic interaction model</li>
              <li data-id="element-106">Annual usage & maintenance</li>
              <li data-id="element-107">Annual review</li>
            </ul>
            <button className="w-full py-3 border border-white/20 hover:bg-white/5 rounded-sm transition-colors" data-id="element-108">
              Apply Now
            </button>
          </div>
          {/* Legacy Tier */}
          <div className="border border-white/20 p-8 rounded-sm bg-gradient-to-b from-zinc-800/50 to-zinc-900/50 backdrop-blur-sm relative overflow-hidden" data-id="element-109">
            <div className="absolute inset-0 bg-[linear-gradient(45deg,rgba(255,255,255,0.03)_25%,transparent_25%,transparent_50%,rgba(255,255,255,0.03)_50%,rgba(255,255,255,0.03)_75%,transparent_75%,transparent)] bg-[length:100px_100px] opacity-20" data-id="element-110"></div>
            <div className="text-sm text-white/70 mb-2" data-id="element-111">CORE PRODUCT</div>
            <h3 className="text-2xl font-light mb-2" data-id="element-112">Legacy</h3>
            <div className="mb-6" data-id="element-113">
              <p className="text-white text-3xl" data-id="element-114">$100,000</p>
              <p className="text-zinc-400 text-sm" data-id="element-115">Setup</p>
            </div>
            <ul className="space-y-3 mb-8 text-zinc-300" data-id="element-116">
              <li data-id="element-117">Complete knowledge transfer</li>
              <li data-id="element-118">Comprehensive behavioral model</li>
              <li data-id="element-119">White glove creation</li>
              <li data-id="element-120">Live multi-day sessions to gather data</li>
              <li data-id="element-121">Family access protocols</li>
              <li data-id="element-122">Voice and visual recreation</li>
            </ul>
            <button className="w-full py-3 bg-white text-black hover:bg-zinc-100 rounded-sm transition-colors" data-id="element-123">
              Apply Now
            </button>
          </div>
          {/* Immortal Tier */}
          <div className="border border-white/30 p-8 rounded-sm bg-gradient-to-b from-white/10 to-transparent backdrop-blur-sm" data-id="element-124">
            <h3 className="text-2xl font-light mb-2" data-id="element-125">Immortal</h3>
            <p className="text-white text-3xl mb-6" data-id="element-126">$1,000,000</p>
            <ul className="space-y-3 mb-8 text-zinc-300" data-id="element-127">
              <li data-id="element-128">Perpetual storage & maintenance</li>
              <li data-id="element-129">Proprietary embodiment technology</li>
              <li data-id="element-130">Complete sensory recreation</li>
              <li data-id="element-131">Adaptability algorithms</li>
              <li data-id="element-132">Distributed secure storage</li>
              <li data-id="element-133">Monthly enhancement sessions</li>
              <li data-id="element-134">Exclusive access protocols</li>
              <li data-id="element-135">Dedicated preservation specialist</li>
              <li data-id="element-136">Bespoke integration options</li>
              <li data-id="element-137">Ability to act in real world</li>
            </ul>
            <button className="w-full py-3 border border-white/30 hover:bg-white/5 rounded-sm transition-colors" data-id="element-138">
              Private Consultation
            </button>
          </div>
        </div>
        <p className="text-center text-zinc-500 mt-12 max-w-2xl mx-auto" data-id="element-139">
          All services begin with a thorough evaluation process. Scion
          Technology reserves the right to decline service based on
          compatibility assessment and ethical considerations.
        </p>
      </div>
    </section>;
};